export default __webpack_public_path__ + "static/yara-b86ba57cebbf45fc64e54bb09cf53191.png";